import { TableHeaderCell } from 'common/components';

export type TableFilterOption = { value: string; label: string; category?: string };

type SMSStatusCellProps = {
    filterSMSStatus: string;
    smsStatusOptions: TableFilterOption[];
    onFilterSMSStatus: (value: string) => void;
};

export const SMSStatusCell = ({ filterSMSStatus, smsStatusOptions, onFilterSMSStatus }: SMSStatusCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...smsStatusOptions];

    return (
        <TableHeaderCell
            label='SMS Status'
            filterOptions={{
                options,
                selectedValue: filterSMSStatus,
                onChange: onFilterSMSStatus,
            }}
            isSearchable
        />
    );
};
